// extracted by mini-css-extract-plugin
export default {"tree_name":"L6yQGW013EAJEZSIGlGL","line_box":"kBCRppi7WIMueioDv6Qh","tree_box":"DZdMt6UDUsWJYDCVQWvE","tabs_box":"OfYvimxZjlAaxoFiX8wU"};